import { useEffect, useState } from 'react';
import { LoginDialog } from './LoginDialog';

export function AuthDialog() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleShowLoginDialog = () => {
      setIsOpen(true);
    };

    window.addEventListener('show-login-dialog', handleShowLoginDialog);
    return () => {
      window.removeEventListener('show-login-dialog', handleShowLoginDialog);
    };
  }, []);

  return <LoginDialog open={isOpen} onOpenChange={setIsOpen} />;
}
